import * as React from 'react';
import { createPortal } from 'react-dom';
import styled, { x, createGlobalStyle } from '@xstyled/styled-components';
import { DocSearchModal, useDocSearchKeyboardEvents } from '@docsearch/react';
import { RiSearchLine } from 'react-icons/ri';
import { Input, InputGroup, InputGroupIcon } from './Input';
require('@docsearch/css');
var GlobalStyle = createGlobalStyle(["body.xstyled-color-mode-dark{--docsearch-text-color:rgb(245,246,247);--docsearch-container-background:rgba(9,10,17,0.8);--docsearch-modal-background:rgb(21,23,42);--docsearch-modal-shadow:inset 1px 1px 0 0 rgb(44,46,64),0 3px 8px 0 rgb(0,3,9);--docsearch-searchbox-background:rgb(9,10,17);--docsearch-searchbox-focus-background:#000;--docsearch-hit-color:rgb(190,195,201);--docsearch-hit-shadow:none;--docsearch-hit-background:rgb(9,10,17);--docsearch-key-gradient:linear-gradient( -26.5deg,rgb(86,88,114) 0%,rgb(49,53,91) 100% );--docsearch-key-shadow:inset 0 -2px 0 0 rgb(40,45,85),inset 0 0 1px 1px rgb(81,87,125),0 2px 2px 0 rgba(3,4,9,0.3);--docsearch-footer-background:rgb(30,33,54);--docsearch-footer-shadow:inset 0 1px 0 0 rgba(73,76,106,0.5),0 -4px 8px 0 rgba(0,0,0,0.2);--docsearch-logo-color:rgb(255,255,255);--docsearch-muted-color:rgb(127,132,151);}"]);
var Kbd = styled.kbd.withConfig({
  displayName: "DocSearch__Kbd",
  componentId: "sc-z4bwrs-0"
})(["border:1;border-color:control-border;margin-right:1;background-color:control-background;text-align:center;padding:0;display:inline-flex;justify-content:center;font-size:0.8em;line-height:1.2;font-family:sans-serif;border-radius:base;min-width:1.5em;"]);
export function DocSearch(_ref) {
  var apiKey = _ref.apiKey,
    indexName = _ref.indexName,
    appId = _ref.appId;
  var searchButtonRef = React.useRef(null);
  var _React$useState = React.useState(false),
    isOpen = _React$useState[0],
    setIsOpen = _React$useState[1];
  var _React$useState2 = React.useState(null),
    initialQuery = _React$useState2[0],
    setInitialQuery = _React$useState2[1];
  var onOpen = React.useCallback(function () {
    setIsOpen(true);
  }, [setIsOpen]);
  var onClose = React.useCallback(function () {
    setIsOpen(false);
  }, [setIsOpen]);
  var onInput = React.useCallback(function (event) {
    setIsOpen(true);
    setInitialQuery(event.key);
  }, [setIsOpen, setInitialQuery]);
  useDocSearchKeyboardEvents({
    isOpen: isOpen,
    onOpen: onOpen,
    onClose: onClose,
    onInput: onInput,
    searchButtonRef: searchButtonRef
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyle, null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InputGroup, {
    ref: searchButtonRef,
    as: "button",
    onClick: function onClick() {
      return onOpen();
    }
  }, /*#__PURE__*/React.createElement(InputGroupIcon, null, /*#__PURE__*/React.createElement(RiSearchLine, null)), /*#__PURE__*/React.createElement(Input, {
    disabled: true,
    type: "search",
    placeholder: "Search..."
  }), /*#__PURE__*/React.createElement(x.div, {
    position: "absolute",
    top: "50%",
    right: 0,
    transform: "translateY(-50%)",
    display: "inline-flex",
    pointerEvents: "none",
    userSelect: "none"
  }, /*#__PURE__*/React.createElement(Kbd, null, "\u2318"), /*#__PURE__*/React.createElement(Kbd, null, "K")))), isOpen && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(DocSearchModal, {
    apiKey: apiKey,
    indexName: indexName,
    appId: appId,
    onClose: onClose,
    initialScrollY: window.scrollY,
    initialQuery: initialQuery
  }), document.body));
}